/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
// libraries
import Image from 'next/image';
import Link from 'next/link';
import { FaFacebook, FaInstagram, FaPhoneAlt, FaTwitter, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { IconEmail, IconFacebook, IconInstagram, IconTelephone, IconThreads, IconTiktok, IconTwitter, IconWhatsapp, IconYoutube } from '../../../assets';
import { MaskPhone } from '../../../utils/FunctionsGlobals';

// utils
import { useRouter } from 'next/router';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import styles from './Topo.module.css';

const Topo: React.FC<{
    site: any;
    setActiveDrawer: any
}> = ({ site, setActiveDrawer }) => {

    const router = useRouter();
    const { codsite } = router.query;
    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: IconInstagram,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.threads || '',
            id: 6,
            icon: IconThreads,
            rede: 'Threads'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: IconFacebook,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: IconTwitter,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: IconTiktok,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: IconYoutube,
            rede: 'Youtube'
        },
    ];

    const openDrawer = () => {
        setActiveDrawer(true);
    };

    const renderText = () => {
        if (site?.id) {
            if(site?.texto_botao_whats){
                return `${site?.texto_botao_whats}`;
            }
            return `Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`;
        }
        return 'Olá, estou visitando o site, gostaria de um atendimento personalizado. Pode me ajudar?';
    };

    return (
        <div className={styles.header_main}>
            {site?.id == '2102' && <img className={styles.header_background2} alt={`Imobiliária ${site?.Dados?.empresa}`} src="https://imob.sobressai.com.br/Banner/2102/11030.jpg"></img>}
            {site?.navbar_transparente && site?.id != '2102' ?
                <div className={styles.header_background}
                    style={site?.tamanho_logo>1 ?
                        site?.id == "2350" ?
                            {background: '#ffffff', opacity: 1} :
                        site?.id == "2098" || site?.id == 2272 ?
                            {opacity: 1, background: site?.cor1,height: site?.tamanho_logo} :
                        site?.id == "2127" ?
                            {opacity: 1,background: site?.cor1,height: site?.tamanho_logo} :
                        site?.id == "2184" ?
                            {opacity: 1,background: site?.cor1,height: site?.tamanho_logo} :
                        { background: site?.cor1, height: site?.tamanho_logo} :
                    {background: site?.cor1}}>
                </div> :
                <div className={styles.header_background}
                    style={site?.tamanho_logo>1 ?{ height: site?.tamanho_logo }:{}}>
                </div>}
            <div className={styles.header_main} style={site?.tamanho_logo>1 ? {height: site?.tamanho_logo} : {}}>
                <div className={styles.flex_ant}/>
                <div className={site?.id == "2127" || site?.id == "2042" || site?.id == "2109" || site?.id == "2130" ?
                                    site?.Dados?.tel1 && site?.id != "2042" ?
                                        styles.flex_photo_center1
                                    :
                                        styles.flex_photo_center
                                :
                                    site?.id == "2014" ?
                                        styles.flex_photo_left
                                    :
                                        styles.flex_photo}

                style={site?.id == '1825' ? {justifyContent: 'left'} : site?.id == 2126 ? {justifyContent: 'center'} : {justifyContent: 'center'}}>
                {site?.url_logo && site?.id != '2102' ? (
                    <Link href={codsite ? "/?codsite="+codsite : "/"}>
                        <img
                            src={site?.id == 2259 ? "https://imob.sobressai.com.br/Banner/2259/11399.jpg" : site?.id == "1706" ? "https://imob.sobressai.com.br/Banner/1706/11072.jpg" : site?.id == "2127" ? "https://imob.sobressai.com.br/Banner/2127/11097.png" : site?.url_logo}
                            alt={`Imobiliária ${site?.Dados?.empresa}`}
                            title={`Imobiliária ${site?.Dados?.empresa}`}
                            className={site?.id == 2331 ? styles.logo_welcome_2331 : site?.id == 2259 ? styles.logo_welcome3 : site?.id == 2304 || site?.id == 2316 ? styles.logo_welcome4 : site?.id == 2178 ? styles.logo_welcome2 : styles.logo_welcome}
                            style={site?.id == 1630 ? {maxHeight: "150px !important"} : site?.id == 2216 ? {maxHeight: "200px !important",marginTop: "20px !important"} : site?.id == 1825 ? {objectPosition: "left",marginLeft: "0px !important"} : site?.id == 1059 ? {minHeight: "171px !important", maxHeight: "171px !important"} : {}}
                            height={site?.tamanho_logo > 1 ? site?.tamanho_logo : 100}
                            width={site?.id == "2112" ? 230 : site?.id == "2109" ? 440 : 340}
                        />
                    </Link>
                ) : (
                    <div className={styles.logo_empty} />
                )}
                {site?.id == 2265 && <img src="https://imob.sobressai.com.br/Banner/2265/11395.jpg" alt="Mascote" style={{maxHeight: 150,height: site?.tamanho_logo > 1 ? site?.tamanho_logo : 100}}/>}
                </div>
                {site?.id == "2106" &&
                    <div className={styles.texto_centro}>
                        <h3>ACREDITAMOS NO SEU SONHO!!!</h3>
                        <h3>Imóveis - Seguros - Consórcios</h3>
                    </div>
                }

                <div className={styles.flex}>
                    {site?.id == "2133" &&
                        <div className={styles.texto_centro}>
                            <a
                                className={styles.btn}
                                style={{
                                    background: `${site?.cor2 || 'rgb(30 30 30)'}`,
                                    border: `1px solid ${site?.cor2 || '#FFFFFF'}`,
                                    color: site?.cor4
                                }}
                                href="https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link" target="_blank" rel="noreferrer">
                                Anuncie
                            </a>
                        </div>
                    }
                    {site?.Dados?.tel1 && site?.id != "2042" && site?.id != "1946" && site?.id != "2057" && site?.id != "2102" ?
                        <a
                            className={styles.flex1}
                            rel="noopener noreferrer"
                            href={site?.Dados?.tel1_whats ? site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`: site?.id == "1937" ? `tel:${(site?.Dados?.tel1)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel1)?.replace(/\D/g, '')}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.Dados?.tel1_whats ? site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`: site?.id == "1937" ? `tel:${(site?.Dados?.tel1)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel1)?.replace(/\D/g, '')}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                             {site?.id == 2259 || site?.id == 1630 || site?.id == 2347 || site?.id == 2331 ?
                                <FaWhatsapp fill='black' style={{display: "flex",alignItems: "center",fontSize: 28,fill: 'white'}}/>
                            :
                            site?.id == 2239 && !site?.Dados?.tel1_whats ?
                            <FaPhoneAlt style={{fontSize: 20, color: "white"}}></FaPhoneAlt>
                            :
                            <Image
                                height={site?.id == 2348 ? 37 : 24}
                                width={site?.id == 2348 ? 37 : 24}
                                alt="Icon Contato 1"
                                title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 1' : 'Icone Telefone 1'}
                                src={site?.Dados?.tel1_whats ? IconWhatsapp : IconTelephone}
                            />}
                            {site?.id != 2331 &&
                                <div
                                    className={styles.columnContato}
                                    style={
                                        site?.cor1 === "#ffffff" && site?.navbar_transparente
                                        ? { color: "black" }
                                        : { color: "white" }
                                    }
                                    >
                                    {site?.id === 1958
                                        ? "+55 (71) 99333-6547"
                                        : site?.id === 1937
                                        ? site?.Dados?.tel1
                                        : MaskPhone(site?.Dados?.tel1)}

                                    {site?.id !== 2243 && (
                                        <div
                                        className={styles.type_number}
                                        style={site?.id == 2348 ? { color: "white",fontSize: 15 } : site?.cor1 === "#ffffff" && site?.navbar_transparente ? { color: "black" } : { color: "white" }}
                                        >
                                        {site?.Dados?.tel1_nome ? site?.Dados?.tel1_nome : "WhatsApp"}
                                        </div>
                                    )}
                                </div>
                            }
                        </a>
                    :null}
                   {site?.id == 2219 && (
                    <a
                        className={styles.flex1}
                        rel="noopener noreferrer"
                        href={`https://api.whatsapp.com/send?phone=5551999711308&text=${renderText()}`}
                        onClick={async (e) => {
                        e.preventDefault(); // Evita redirecionamento automático
                        trackLead(site, null); // Registra o evento Lead
                        
                        setTimeout(() => {
                            window.open(
                            `https://api.whatsapp.com/send?phone=5551999711308&text=${renderText()}`,
                            "_blank"
                            );
                        }, 300);
                        }}
                    >
                        <Image
                        height={24}
                        width={24}
                        alt="Icone WhatsApp 2219"
                        title="Icone WhatsApp 2219"
                        src={IconWhatsapp}
                        />
                        <div
                        className={styles.columnContato}
                        style={
                            site?.cor1 === "#ffffff" && site?.navbar_transparente
                            ? { color: "black" }
                            : { color: "white" }
                        }
                        >
                        {MaskPhone("51999711308")}
                        <div
                            className={styles.type_number}
                            style={
                            site?.cor1 === "#ffffff" && site?.navbar_transparente
                                ? { color: "black" }
                                : { color: "white" }
                            }
                        >
                            Luci Argenta
                        </div>
                        </div>
                    </a>
                    )}
                    {site?.Dados?.tel2 && site?.id != "2042" && site?.id != "1946" && site?.id != "2057" && site?.id != "2102" && site?.id != "2288" ?
                        <a
                            className={styles.flex1}
                            rel="noopener noreferrer"
                            href={site?.Dados?.tel2_whats ? site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel2)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel2)?.replace(/\D/g, '')}&text=${renderText()}`: site?.id == "1937" ? `tel:${(site?.Dados?.tel2)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel2)?.replace(/\D/g, '')}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.Dados?.tel2_whats ? site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel2)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel2)?.replace(/\D/g, '')}&text=${renderText()}`: site?.id == "1937" ? `tel:${(site?.Dados?.tel2)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel2)?.replace(/\D/g, '')}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                            {site?.id == 2259 || site?.id == 1630 ?
                                <FaWhatsapp fill='black' style={{display: "flex",alignItems: "center",fontSize: 28,fill: 'white'}}/>
                            :
                            site?.id == 2239 && !site?.Dados?.tel2_whats ?
                            <FaPhoneAlt style={{fontSize: 20, color: "white"}}></FaPhoneAlt>
                            :
                            <Image
                                height={24}
                                width={24}
                                alt="Icon Contato 2"
                                title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 2' : 'Icone Telefone 2'}
                                src={site?.Dados?.tel2_whats ? IconWhatsapp : IconTelephone}
                            />}
                            <div className={styles.columnContato } style={site?.cor1 == "#ffffff" && site?.navbar_transparente ? {color: "black"} : {color: "white"}}>
                                {site?.id == "1937" ? site?.Dados?.tel2 : MaskPhone(
                                        site?.Dados?.tel2
                                )}
                                <div className={styles.type_number} style={site?.cor1 == "#ffffff" && site?.navbar_transparente ? {color: "black"} : {color: "white"}}>
                                    {site?.Dados?.tel2_nome ? site?.Dados?.tel2_nome : "Comercial"}
                                </div>
                            </div>
                        </a>
                    :null}
                    {site?.id == 1825 ?
                        <a
                            className={styles.flex1}
                            rel="noopener noreferrer"
                            href={`https://api.whatsapp.com/send?phone=+5547991389248}&text=${renderText()}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    `https://api.whatsapp.com/send?phone=+5547991389248}&text=${renderText()}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                            {site?.id == 1630 && site?.Dados?.tel2_whats ?
                                <FaWhatsapp style={{fontSize: 28, color: "white"}}/>
                                :
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 2"
                                    title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 2' : 'Icone Telefone 2'}
                                    src={site?.Dados?.tel2_whats ? IconWhatsapp : IconTelephone}
                                />
                            }
                            <div className={styles.columnContato } style={site?.cor1 == "#ffffff" && site?.navbar_transparente ? {color: "black"} : {color: "white"}}>
                                (47) 99138-9248
                                <div className={styles.type_number} style={site?.cor1 == "#ffffff" && site?.navbar_transparente ? {color: "black"} : {color: "white"}}>
                                    Locação
                                </div>
                            </div>
                        </a>
                    :null}
                    {site?.redes_topo &&
                        <>
                        {site?.id == "1836" &&
                            <a className={styles.blog} href="https://antigo.estilogramadoimoveis.com.br/blog">
                                Blog
                            </a>
                        }
                        <div className={styles.redes_sociais}>
                            <div className={styles.container1} style={{display: 'flex'}}>
                                {site?.id == "2321" &&
                                    <a
                                        rel="noopener noreferrer"
                                        href="mailto:contato@fcaimoveis.com.br"
                                        target='_blank'
                                        title={`Navegar para o email da imobiliária`}
                                        className={styles.adjust_img1}
                                    >
                                        <Image
                                            alt={`Imagem Email`}
                                            src={IconEmail}
                                            height={30}
                                            width={30}
                                        />
                                    </a>
                                }
                                {allSocials?.map((v) => {
                                    if (v) {
                                        if (v.href) {
                                            return (
                                                <a
                                                    aria-label={v.href}
                                                    rel="noopener noreferrer"
                                                    key={v.id}
                                                    href={v.href}
                                                    title={`Navegar para o ${v.rede} da imobiliária`}
                                                    onClick={async (e) => {
                                                        e.preventDefault(); // Evita o redirecionamento automático

                                                        trackLead(site, null); // 🔥 Registra o evento Lead

                                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                                        setTimeout(() => {
                                                        window.open(
                                                            v.href,
                                                            "_blank"
                                                        );
                                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                    }}
                                                    className={styles.adjust_img1}
                                                    style={site?.id == 2245 && v.id == 3 ?{color: "#ffffff",display: "flex",alignItems: "center",gap: 5,justifyItems: "center",fontWeight: 600}  : {}}
                                                >
                                                    {site?.id == 2115 || site?.id == 1630 || site?.id == 2346 ?
                                                        v.rede == "Facebook" ?
                                                        <FaFacebook style={{fontSize: 28, color: "white"}}/>
                                                        :
                                                        v.rede == "Instagram" ?
                                                        <FaInstagram style={{fontSize: 28, color: "white"}}/>
                                                        :
                                                        v.rede == "Youtube" ?
                                                            <FaYoutube style={{fontSize: 28, color: "white"}}/>
                                                        : <Image
                                                            alt={`Imagem rede social ${v.rede}`}
                                                            src={v.icon}
                                                            height={30}
                                                            width={30}
                                                        />
                                                    : site?.id == 2259 ?
                                                        v?.id == 3 ? <FaInstagram fill='black' style={{display: "flex",alignItems: "center",fontSize: 28,fill: 'white'}}/> :
                                                        v?.id == 1 ? <FaFacebook fill='black' style={{display: "flex",alignItems: "center",fontSize: 28,fill: 'white'}}/> :
                                                        v?.id == 2 ? <FaYoutube fill='black' style={{display: "flex",alignItems: "center",fontSize: 28,fill: 'white'}}/> :
                                                        v?.id == 4 ? <FaTwitter fill='black' style={{display: "flex",alignItems: "center",fontSize: 28,fill: 'white'}}/> :
                                                        <Image
                                                            alt={`Imagem rede social ${v.rede}`}
                                                            src={v.icon}
                                                            height={37}
                                                            width={37}
                                                        />
                                                    :
                                                    <Image
                                                        alt={`Imagem rede social ${v.rede}`}
                                                        src={v.icon}
                                                        height={site?.id == 2348 ? 37 : 30}
                                                        width={site?.id == 2348 ? 37 : 30}
                                                    />
                                                    }
                                                    {
                                                        site?.id == 2245 && v.id == 3 && "@w.m_imoveis"
                                                    }
                                                </a>
                                            );
                                        }
                                        return null;
                                    }
                                    return null;
                                })}
                            </div>
                        </div>
                        </>
                    }
                    <div className={styles.options_header_welcome}>
                        <div
                            className={styles.icon_drawer}
                            onClick={openDrawer}
                        >
                            <svg
                                viewBox="0 0 24 24"
                                height="1.75rem"
                                width="1.75rem"
                                aria-hidden="true"
                                focusable="false"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                style={site?.cor1 == "#ffffff" && site?.navbar_transparente ? { fill: 'black' } : { fill: 'white' }}
                            >
                                <path fill="none" d="M0 0h24v24H0V0z"></path>
                                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Topo;

